import { render } from "./NotFound.vue?vue&type=template&id=01ce82a0&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=01ce82a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01ce82a0"

export default script